<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        文件上传demo
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="上传文件">
        <el-upload class="upload-demo" drag action="." :http-request="upload" multiple list-type="text" :limit="3" :on-progress="progress">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>

      <div class="btn" @click="onSubmit">保存</div>
      <div class="btn ml20">取消</div>
    </el-form>
  </div>
</template>

<script>
import OSS from "ali-oss";
let client = new OSS({
  region: "oss-cn-qingdao",
  secure: false,
  accessKeyId: "LTAI4GKvgzv3fMwZHJhGGoDZ",
  accessKeySecret: "LizYse236n6NzFAKgxdsgUhMUM1fNZ",
  bucket: "zhidui-video",
});

export default {
  data() {
    return {
      form: {
        uploaddata: "",
      },
    };
  },
  created() {
    // 暂停分片上传。
  },
  methods: {
    progress(event, file, fileList) {
      log(event);
    },
    upload(val) {
      log(val);
      let file = val.file;
      let tempCheckpoint;

      let progress = function progress(p, checkpoint) {
        console.log(p);
      };

      // 定义上传方法。
      async function multipartUpload() {
        try {
          //object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
          let result = await client.multipartUpload("test", file, {
            progress: function(p, checkpoint) {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发继续上传。
              tempCheckpoint = checkpoint;
            },
            meta: { people: "test", time: Date().now },
          });
        } catch (e) {
          console.log(e);
        }
      }

      // 开始分片上传。
      multipartUpload();
    },
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>

<style scoped></style>
